import React, { useEffect } from "react";
import DMSHeader from "../../DMSHeader/DMSHeader";
//import DailyFloodReportCompTable from "./DailyFloodReportCompTable";
import { useTranslation } from "react-i18next";
import DailyCloudBurstReportForm from "./DailyCloudBurstReportForm";
import "../ReportEnhanced.css";

const DailyCloudBurstReport = () => {
  const { t } = useTranslation();

  return (
    <div className="report-enhanced-wrapper">
      <div className="report-header-enhanced">
        <DMSHeader title="Cloud Burst Daily Report" />
      </div>
      <div className="report-table-enhanced">
        <DailyCloudBurstReportForm />
      </div>
    </div>
  );
};

export default DailyCloudBurstReport;
